import React, { Component } from "react";
import { Row, Col, Form, Button, Card, Accordion } from "react-bootstrap";
import { RotateLoader } from "react-spinners";
import { bookAppointment } from "../services/blinkai";

export class Confirm extends Component {
  state = {
    loading: false,
  };

  continue = (e) => {
    e.preventDefault();
    this.submit();
  };

  submit = () => {
    // Process Form
    this.setState({ loading: true });
    const { storeId, phone, email, firstName, lastName, date, optedIn, pickup, serviceType, paramCampaignId, paramSession, notes } = this.props.values;
    bookAppointment(storeId, phone, email, firstName, lastName, date, optedIn, pickup, serviceType, paramCampaignId, paramSession, notes)
      .then((res) => {
        this.setState({ loading: false });
        this.props.nextStep();
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false });
      });
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  firstStep = (e) => {
    e.preventDefault();
    this.props.goToStep(1);
  };

  render() {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const {
      values: { firstName, lastName, email, date, phone, pickup, pickupOptionEnabled, notesEnabled, notes },
      handleChange,
    } = this.props;
    const month = months[date.getMonth()];
    const day = date.getUTCDate();
    const dayOfWeek = days[date.getDay()];
    const time = date.toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });
    return (
      <React.Fragment>
        <h3>Review Information</h3>
        <hr />
        {!this.state.loading && (
          <Row>
            <Col>
              <React.Fragment>
                <Form onSubmit={this.continue}>
                  <Row>
                    <Col xs="4">
                      <div className="date">
                        <span className="binds" />
                        <span className="month" id="summary-month">
                          {month}
                        </span>
                        <div className="day-box">
                          <h1 className="day" id="summary-day">
                            {day}
                          </h1>
                          <small className="dayOfWeek" id="summary-dayOfWeek">
                            {dayOfWeek}
                          </small>
                        </div>
                        <span className="time" id="summary-time">
                          {time}
                        </span>
                      </div>
                    </Col>
                    <Col xs="8">
                      <h5 className="limited-text text-uppercase" id="summary-name">
                        {firstName} {lastName}
                      </h5>
                      <hr />
                      <div className="limited-text" id="summary-phone">
                        {phone}
                      </div>
                      <div className="limited-text" id="summary-email">
                        {email}
                      </div>
                      {notesEnabled && (
                        <div className="limited-text" id="summary-notes">
                          <Accordion defaultActiveKey="0">
                            <Accordion.Toggle as={Button} variant="link" className="dotted-border" eventKey="1">
                              &#8853; Add Comments
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="1">
                              <Form.Control
                                className="notes"
                                as="textarea"
                                rows="3"
                                name="notes"
                                defaultValue={notes}
                                autoFocus={true}
                                onChange={(e) => {
                                  handleChange({
                                    notes: e.target.value,
                                  });
                                }}
                              />
                            </Accordion.Collapse>
                          </Accordion>
                        </div>
                      )}
                    </Col>
                  </Row>
                  {pickupOptionEnabled && (
                    <Row className="mt-2">
                      <Col>
                        <Card border="warning">
                          <Card.Header className="header-warning">
                            <b>COVID-19: FREE CAR PICKUP</b>
                          </Card.Header>
                          <Card.Body>
                            <Card.Text>We have special pickup feature available to accomodate customers who want their car to be picked up from their home for no additional charge.</Card.Text>
                            <Form.Check
                              name="pickup"
                              type="checkbox"
                              label="I would like to request CAR PICKUP for my appointment"
                              defaultChecked={pickup}
                              onChange={(e) =>
                                handleChange({
                                  pickup: e.target.checked,
                                })
                              }
                            />
                            <Form.Label className="text-smaller">
                              By checking this, we do not guarantee pickup for your appointment. We will reach out to you to confirm and schedule pickup to make sure we can provide you optimum
                              service. You will NOT be charged extra for this service.
                            </Form.Label>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  )}
                  <div className="text-center">
                    <Button id="changeInput" variant="link" type="button" onClick={this.firstStep}>
                      &laquo; Edit Appointment
                    </Button>
                  </div>
                  <Button size="lg" block variant="primary" type="submit">
                    Book Appointment
                  </Button>
                </Form>
              </React.Fragment>
            </Col>
          </Row>
        )}
        <div className="text-center loader">
          <RotateLoader color={"#337ab7"} loading={this.state.loading} />
        </div>
      </React.Fragment>
    );
  }
}

export default Confirm;
